import React, {useContext}  from 'react';
import { GlobalContext } from '../../../Contexts/GlobalContext';

const Section3 = ()=>{

    const {URL} = useContext(GlobalContext);
    const alumniDonorImg = URL + "images/home/alumniDonor.jpg";

    return(

            <div className="section3" style={{ backgroundImage:"url("+ alumniDonorImg +")" }}>
                <div className="row alumniDonor">
                    <div className="col-12 alumniDonorWrapper">
                        <h2>
                            Alumni Donor  
                        </h2>
                        <p>
                            You can support LUMS in a variety of ways - from gifts towards our financial aid and NOP scholars or towards infrastructure and research. To make this gift, please use our secure online giving form. The process consists of a few easy steps and will only take a moment but the impact will last a lifetime..
                        </p>
                        <div className="link">
                            <a href="/">
                                Donate Now <i className="fa fa-caret-right"></i>
                            </a>
                        </div>
                      </div>
                </div>
            </div>
        );

    }
    
    export default React.memo(Section3);